<mat-sidenav-container class="sidenav-container">
  <mat-sidenav-content class="">
    <app-vertical-navbar *ngIf="!isMobile()" [menu]="appMenu()" [shortcut1]="appMenu()[0]"></app-vertical-navbar>
    <app-bottom-navbar *ngIf="isMobile()" [menu]="appMenu()"></app-bottom-navbar>
    <div [style.margin-left.px]="isMobile() ? 0 : (isCollapsed ? 50 : 250)" [style.padding-bottom.px]="isMobile() ? 50 : 0" class="container flex flex-column"
         id="container" name="container">
      <app-header  [title]="title()" [logo]="logo()" [showTitle]="showTitle()" [showLogo]="showLogo()"></app-header>
      <div [@routeAnimations]="getRouteAnimationData()" class="overflow-y-auto flex-grow-1">
        <router-outlet  *ngIf="isSetRole()"></router-outlet>
      </div>
    </div>
  </mat-sidenav-content>
  <mat-sidenav
    #leftPanel
    (closed)="sidenavService.clearContents('start')"
    [class]="'panel-'+sidenavService.size"
    [fixedInViewport]="true"
    mode="over"
    position="start">
    <ng-template [cdkPortalOutlet]="sidenavService.leftSidenavPortal | async"></ng-template>
  </mat-sidenav>
  <mat-sidenav
    #rightPanel
    (closed)="sidenavService.clearContents('end')"
    [class]="'panel-'+sidenavService.size"
    [fixedInViewport]="true"
    mode="over"
    position="end">
    <ng-template [cdkPortalOutlet]="sidenavService.rightSidenavPortal | async"></ng-template>
  </mat-sidenav>
</mat-sidenav-container>
<app-spinner></app-spinner>

